const messages = {
  dashboard: {
    title: "Kontrolna tabla servisa",
    description:
      "Srdačno dobrodošli na vašu kontrolnu tablu. Ovdje možete pregledati trenutne pokazatelje i učesnike iz vaše klijentske baze.",
    overview: {
      title: "Pregled učesnika kupaca",
      description:
        'Kompanije koje su se registrovale na BRIDGESTONE <span class="text-danger">PLUS</span> i koje možemo povezati sa vama preko broja kupca.',
      month: "Novo ovog mjeseca",
      year: "Novo ove godine",
      all: "Ukupno",
    },
    credits: {
      title: "Uknjižavanje bodova",
      description:
        "Nagradni bodovi dodijeljeni učesnicima na osnovu dostavljenih podataka o prodaji.",
      month: "Prošli mjesec",
      year: "Tekuća godina",
      prev_year: "Ukupno",
      allDealers: "Svi bodovi trgovaca",
      allPoints: "Svi bodovi",
      prev_month: "Prošli mjesec",
    },
    details: {
      title: "Učesnici kupci detaljno",
      description:
        'U nastavku su navedene kompanije koje su se registrovale na BRIDGESTONE <span class="text-danger">PLUS</span> sa Bridgestone brojem kupca i koje su vam dodijeljene kao odgovornom. Jednostavno koristite funkcije sortiranja za drugačiji redoslijed ili funkciju pretrage.<br/><br/> <b>Napomena:</b> Ako kliknete na stanje bodova, doći ćete do detaljnog izvještaja računa.',
    },
    lastImport:
      'Zadnji uvoz podataka o prodaji: <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Učesnicima se kešbek naknade uknjižavaju na osnovu dostavljenih podataka o prihodima.",
    },
    tyres: {
      title: "Gume",
      description: "Gume kupljene od strane učesnika programa",
    },
    short:
      "Dobrodošli na vašu kontrolnu tablu. Ovdje možete pregledati trenutne podatke i kompanije učesnice iz vaše klijentske baze.",
    headers: {
      city: "Grad",
      company: "Kompanija",
      current_points: "trenutni bodovi",
      customer_number: "broj kupca",
      details: "detalji",
      last_login: "Zadnja prijava",
      name: "ime",
      postal_code: "Poštanski broj",
      street: "ulica",
      email: "Email",
    },
    reload: "Ponovo učitaj",
    exports: {
      title: "Izvezeni Excel fajlovi",
      downloadExcel: "Preuzmi Excel",
      running: "U toku",
      head: {
        name: "Naziv",
        status: "Status",
      },
    },
  },
};
export default {
  messages,
};
